module.exports = __webpack_public_path__ + "img/图3.a09a7c40.png";